<template>
  <span
    class="dwp-inline-flex rounded-md"
    :class="[type !== 'plain' ? 'shadow-sm' : '', widthClass]"
  >
    <button
      :type="buttonType"
      class="dwp-inline-flex dwp-items-center dwp-justify-center dwp-border dwp-border-transparent dwp-leading-4 dwp-font-medium focus:dwp-outline-none dwp-transition dwp-ease-in-out dwp-duration-150"
      :class="[sizeClass, colorClass, roundedClass, widthClass]"
    >
      <slot />
    </button>
  </span>
</template>

<script>
export default {
  props: {
    size: String,
    type: String,
    disabled: Boolean,
    buttonType: {
      type: String,
      default: "button",
    },
    rounded: String,
    buttonWidth: String,
  },
  computed: {
    widthClass() {
      return this.buttonWidth == "full" ? "dwp-w-full" : "";
    },
    roundedClass() {
      return this.rounded == "full" ? "dwp-rounded-full" : "dwp-rounded";
    },
    sizeClass() {
      switch (this.size) {
        case "tiny":
          return "dwp-px-2 dwp-py-1 dwp-text-xs";
          break;
        case "small":
          return "dwp-px-3 dwp-py-2 dwp-text-sm";
          break;
        default:
          return "dwp-px-4 dwp-py-2 dwp-text-sm";
          break;
        case "large":
          return "dwp-px-4 dwp-py-2 dwp-text-base";
          break;
        case "huge":
          return "dwp-px-6 dwp-py-3 dwp-text-base";
          break;
      }
    },
    colorClass() {
      switch (this.type) {
        case "plain":
          return "dwp-bg-transparent hover:dwp-bg-transparent dwp-text-gray-500";
          break;
        case "outline":
          return "dwp-bg-transparent hover:dwp-bg-transparent dwp-text-gray-600 dwp-border hover:dwp-opacity-75 dwp-border-gray-500";
          break;
        default:
          let colors = "dwp-bg-primary dwp-text-white";
          if (!this.disabled) {
            colors += " hover:dwp-opacity-75 focus:dwp-shadow-outline-blue";
          } else {
            colors += " dwp-opacity-50";
          }
          return colors;
          break;
      }
    },
    disabledClass() {
      if (!this.disabled) {
      }
    },
  },
};
</script>
